import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Spinner } from "react-bootstrap";
import { StudentAvatarAction } from "../Redux/Action/StudentAction";

const StudentsImagesModal = ({ studentModalshow, handleCloseStudentModal, setSlectedImage }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const Images = useSelector(state => state.studentSlice.avatars);

  useEffect(() => {
    getStudentImage();
  }, []);

  const getStudentImage = () => {
    setLoading(true);
    dispatch(StudentAvatarAction()).finally(() => {
      setLoading(false);
    });
  };

  return (
    <Modal
      size="lg"
      show={studentModalshow}
      onHide={handleCloseStudentModal}
      className="comn-modal-set"
    >
      <Modal.Header closeButton className="border-none">
        <Modal.Title className="text-center">Choose Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="collections-list-pro">
          <Row>
            {loading ? (
              <div className="d-flex justify-content-center w-100">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : Array.isArray(Images) && Images.length > 0 ? (
              <>
                {Images.map((num, index) => (
                  <React.Fragment key={index}>
                    {num.image ? (
                      <Col lg={2}>
                        <div
                          onClick={() => {
                            setSlectedImage(num.image)
                            handleCloseStudentModal()
                          }}
                          className="search-history-list collect-box"
                        >
                          <div className="viewing-h-pro">
                            <img src={num.image} alt="User avatar thumbnail" />
                          </div>
                        </div>
                      </Col>
                    ) : null}
                  </React.Fragment>
                ))}
              </>
            ) : (
              <p className="data-not-found-cmn">Data Not Found</p>
            )}
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-none justify-content-center">
      </Modal.Footer>
    </Modal>
  );
};

export default StudentsImagesModal;
